import { render, staticRenderFns } from "./DomainPerformance.vue?vue&type=template&id=5b1d0713&scoped=true&"
import script from "./DomainPerformance.vue?vue&type=script&lang=ts&"
export * from "./DomainPerformance.vue?vue&type=script&lang=ts&"
import style0 from "./DomainPerformance.vue?vue&type=style&index=0&id=5b1d0713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1d0713",
  null
  
)

export default component.exports